module.exports = __webpack_public_path__ + "img/investment-history-grey56.a3df1468.svg";